
import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Badge } from "@/components/ui/badge";

interface ExpertApplicationsTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  getStatusCount: (status: string) => number;
  children: React.ReactNode;
}

export default function ExpertApplicationsTabs({
  activeTab,
  onTabChange,
  getStatusCount,
  children
}: ExpertApplicationsTabsProps) {
  return (
    <Tabs value={activeTab} onValueChange={onTabChange} className="space-y-6">
      <TabsList className="grid w-full grid-cols-4 h-12">
        <TabsTrigger value="pending" className="flex items-center gap-2 text-sm">
          Pending
          <Badge variant="secondary" className="text-xs min-w-[20px] h-5">
            {getStatusCount("pending")}
          </Badge>
        </TabsTrigger>
        <TabsTrigger value="approved" className="flex items-center gap-2 text-sm">
          Approved
          <Badge variant="secondary" className="text-xs min-w-[20px] h-5 bg-blue-100 text-blue-800">
            {getStatusCount("approved")}
          </Badge>
        </TabsTrigger>
        <TabsTrigger value="rejected" className="flex items-center gap-2 text-sm">
          Rejected
          <Badge variant="secondary" className="text-xs min-w-[20px] h-5 bg-red-100 text-red-800">
            {getStatusCount("rejected")}
          </Badge>
        </TabsTrigger>
        <TabsTrigger value="published" className="flex items-center gap-2 text-sm">
          Published
          <Badge variant="default" className="text-xs min-w-[20px] h-5 bg-green-600 text-white">
            {getStatusCount("published")}
          </Badge>
        </TabsTrigger>
      </TabsList>

      <TabsContent value={activeTab} className="space-y-4 mt-6">
        {children}
      </TabsContent>
    </Tabs>
  );
}
